import EmptyState from '@atlaskit/empty-state';
import { SpinnerMask } from '@atlassian/amkt-common';
import { GenericErrorImage, TabHeader } from '@atlassian/developer-space';
import React from 'react';
import PartnerSecurityDetails from './PartnerSecurityDetails';
const PartnerSecurity = _ref => {
  let {
    partnerDetails
  } = _ref;
  const {
    isPartnerDetailsPending,
    isPartnerDetailsRejected
  } = partnerDetails;
  if (isPartnerDetailsRejected) {
    return /*#__PURE__*/React.createElement(EmptyState, {
      header: "We ran into a little trouble",
      description: "It might just be a hiccup. Try again in a bit.",
      imageUrl: GenericErrorImage
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabHeader, {
    headerText: "Security"
  }), /*#__PURE__*/React.createElement(SpinnerMask, {
    active: isPartnerDetailsPending,
    size: 50
  }, /*#__PURE__*/React.createElement(PartnerSecurityDetails, null)));
};
export default PartnerSecurity;